import { FooterComponent } from "./footer/footer.component";
import { SideNavigationComponent } from "./side-navigation/side-navigation.component";
import { ProfileDisplayComponent } from "./profile-display/profile-display.component";
import { CommunicationAddressesComponent } from "./communication-addresses/communication-addresses.component";
import { CommunicationAddressEmailComponent } from "./communication-address-email/communication-address-email.component";
import { CommunicationAddressEmailsComponent } from "./communication-address-emails/communication-address-emails.component";
import { CommunicationAddressPhonesComponent } from "./communication-address-phones/communication-address-phones.component";
import { CommunicationAddressPhoneComponent } from "./communication-address-phone/communication-address-phone.component";

export const containers: any[] = [
  FooterComponent,
  SideNavigationComponent,
  ProfileDisplayComponent,
  CommunicationAddressesComponent,
  CommunicationAddressEmailsComponent,
  CommunicationAddressEmailComponent,
  CommunicationAddressPhonesComponent,
  CommunicationAddressPhoneComponent,
];

export * from "./footer/footer.component";
export * from "./side-navigation/side-navigation.component";
export * from "./profile-display/profile-display.component";
export * from "./communication-addresses/communication-addresses.component";
export * from "./communication-address-emails/communication-address-emails.component";
export * from "./communication-address-email/communication-address-email.component";
export * from "./communication-address-phones/communication-address-phones.component";
export * from "./communication-address-phone/communication-address-phone.component";
